import { LogoutOutlined, MailOutlined } from "@ant-design/icons";
import { useAuth0 } from "@auth0/auth0-react";
import { Dropdown } from "antd";
import React, { useEffect, useState } from "react";
import { BiCube } from "react-icons/bi";
import {
  Menu,
  MenuItem,
  ProSidebar,
  SidebarFooter,
  SidebarHeader,
} from "react-pro-sidebar";
import { useHistory, useLocation } from "react-router-dom";
import { checkIfArtistExists } from "../../api/dmmeendpoints/checkIfUserExists";
import { createArtist } from "../../api/dmmeendpoints/createArtist";
import { ReactComponent as CommunityIcon } from "../../assets/Dashboard/community.svg";
import Logo from "../../assets/Dashboard/iindy.png";
import { ReactComponent as PlaybookIcon } from "../../assets/Dashboard/playbook.svg";
import { ReactComponent as SendIcon } from "../../assets/Dashboard/send-01.svg";
import Center from "../../components/Center/Center";
import Loading from "../../SignupProcess/Loading/Loading";
import Collections from "./Collections/Collections";
import Community from "./Community/Community";
import "./Dashboard.scss";
import { Insights } from "./Insights/Insights";
import Playbook from "./Playbook/Playbook";
import { FiImage } from "react-icons/fi";
import { customNotification } from "../../helpers/customNotification";
import { s3Upload } from "../../helpers/s3Upload";
import { mimeTypes } from "../../helpers/getMimeType";
import { updateUser } from "../../api/endpoints/createUser";
import { artistUpdate } from "../../api/dmmeendpoints/artistUpdate";
import useInactivityTimer from "../../hooks/useInactivityTimer";
import TipsModal from "../../components/TipsModal/TipsModal";
import InactiveModal from "../../components/InactiveModal/InactiveModal";

export default function Dashboard() {
  const { user, isAuthenticated, isLoading, loginWithRedirect, logout } =
    useAuth0();
  const [activePanelIndex, setActivePanelIndex] = useState(0);
  const [activeStep, setActiveStep] = useState(0);
  const history = useHistory();
  const location = useLocation();
  const [loginUser, setLoginUser] = useState();
  const [inactive, setInactive] = useInactivityTimer();

  const dbUser = JSON.parse(localStorage.getItem("dbUser"));

  useEffect(() => {
    const localUser = JSON.parse(localStorage.getItem("loginUser"));
    setLoginUser(localUser);
  }, []);

  const menu = [
    // { label: "Goals", icon: GoalsIcon, path: "/dashboard/goals/select" },
    { label: "Community", icon: CommunityIcon, path: "/dashboard/community" },
    { label: "Broadcasts", icon: SendIcon, path: "/dashboard/broadcasts" },
    {
      label: "Playbooks",
      icon: PlaybookIcon,
      path: "/dashboard/playbooks",
    },
    {
      label: "Collections",
      icon: () => <BiCube size={24} />,
      path: "/dashboard/collections",
    },
    // { label: "Insights", icon: InsightsIcon, path: "/dashboard/insights" },
    // { label: "75 £", icon: GiftIcon, special: true, path: "/dashboard/promo" },
  ];
  useEffect(() => {
    //
    setActivePanelIndex(
      menu.findIndex((item) => location.pathname.includes(item.path))
    );
    if (location.pathname === "/dashboard/goals/platform") {
      setActiveStep("platform");
      setActivePanelIndex(0);
    } else if (location.pathname === "/dashboard") {
      history.push("/dashboard/community");
    } else {
      setActiveStep(0);
    }
  }, [location.pathname]);
  useEffect(() => {
    if (!isAuthenticated && !isLoading && !user) {
      history.push("/");
    }
  }, [isAuthenticated, user, isLoading]);
  const logoutWithRedirect = () => {
    logout({ returnTo: window.location.origin });
    localStorage.clear();
  };
  useEffect(() => {
    let idleTimeout;
    if (isLoading) {
      idleTimeout = setTimeout(() => {
        logout({ returnTo: window.location.origin });
        localStorage.clear();
      }, 5000);
    }
    return () => {
      clearTimeout(idleTimeout);
    };
  }, [isLoading]);

  useEffect(() => {
    const checkIfExists = async () => {
      if (user) {
        const { config_json } = await checkIfArtistExists(user.name);
        if (config_json) {
          if (config_json.status?.twilioStatus === "closed_on_twilio") {
            history.push("/welcome", { status: "closed-account" });
          } else if (!config_json.bot_config) {
            history.push("/message-flow-builder");
          } else if (!config_json.claimed_phone_number) {
            history.push("/get-your-number");
          }
        } else {
          history.push("/");
        }
      }
    };
    checkIfExists();
  }, [user, isLoading]);
  const inputRef = React.useRef(null);

  const items = [
    {
      label: (
        <div
          className="tile-dropdown-item"
          onClick={() => inputRef?.current.click()}
        >
          <FiImage /> Change logo
        </div>
      ),
      key: "0",
    },
    {
      label: (
        <div className="tile-dropdown-item">
          <MailOutlined /> {user?.email || ""}
        </div>
      ),
      key: "1",
    },
    {
      label: (
        <div className="tile-dropdown-item" onClick={logoutWithRedirect}>
          <LogoutOutlined /> Logout
        </div>
      ),
      key: "2",
    },
  ];

  useEffect(() => {
    const checkIfExists = async () => {
      const localUser = JSON.parse(localStorage.getItem("loginUser"));
      if (user?.name && localUser) {
        const response = await checkIfArtistExists(user.name);
        if (!response) {
          createArtist({
            work_email: user.name,
            artist_id: user.sub,
            artist_name: localUser.artistName,
            company_name: localUser.companyName,
            full_name: localUser.fullName,
          });
        }
      }
    };
    checkIfExists();
  }, [user, isLoading, isAuthenticated]);

  useEffect(() => {}, [isLoading]);
  const handleChange = function (e) {
    e.preventDefault();
    uploadFunction(e.target.files);
  };
  const uploadFunction = async (files) => {
    uploader(files[0]);
  };
  let shortUrls = [];
  const setShortUrls = async (urls) => {
    const newProfilePic = urls[0];
    console.log(newProfilePic, "NEWPROF");
    const profile = JSON.parse(localStorage.getItem("dbUser"));
    profile.bot_config.contact_info.profile_picture = newProfilePic;
    localStorage.setItem("dbUser", JSON.stringify(profile));
    await artistUpdate({
      object: {
        bot_config: {
          ...profile.bot_config,
          active_nft_series_id:
            profile.bot_config.active_nft_series_id ||
            "welcome_bot_nft_series_1",
        },
      },
      artistId: user.sub,
    });
    window.location.reload();

    // update(urls[0]);
    // const assetType = getMimeType(longUrl) || "image";
    // setData({
    //   ...data,
    //   series_asset_path: urls[0],
    //   series_asset_s3_path: `files/${sanitizeFileName(
    //     longUrl?.substring(longUrl.indexOf("files/") + 6)
    //   )}`,
    //   series_asset_type: assetType,
    // });
  };
  const uploader = async (file) => {
    if (file.size > 25 * 1e6) {
      customNotification("`File size too big`", null, "Max size is 25mb", "");
    } else if (!Object.values(mimeTypes).includes(file.type)) {
      customNotification(
        "Sorry, that media type is not yet supported.",
        null,
        `Please upload JPG, PNG, GIF, SVG, GLTF, GLB, MOV, or MP4 file. Max size is 25mb`
      );
    } else {
      s3Upload(file, [0], () => {}, 0, shortUrls, setShortUrls);
    }
  };

  return (
    <div className={"dashboard-wrapper"}>
      {isLoading ? (
        <Center>
          <Loading />
        </Center>
      ) : (
        <div className="row">
          <ProSidebar collapsed={true} onToggle={(e) => {}}>
            <SidebarHeader>
              <img src={Logo} />
            </SidebarHeader>
            <Menu iconShape="square">
              {menu.map((item, i) => (
                <MenuItem
                  key={i}
                  onClick={() => history.push(item.path)}
                  icon={
                    <div
                      className={`my-menu-item ${
                        item.label === "Broadcasts" ? "my-menu-item-stroke" : ""
                      } ${item.special ? " special" : ""}${
                        activePanelIndex === i
                          ? ` my-active ${
                              item.label === "Broadcasts"
                                ? "my-active-stroke"
                                : ""
                            }`
                          : ""
                      }`}
                    >
                      <item.icon />
                      {item.label}
                    </div>
                  }
                ></MenuItem>
              ))}
            </Menu>
            <SidebarFooter>
              <Dropdown
                menu={{ items }}
                placement="topRight"
                arrow={{
                  pointAtCenter: true,
                }}
              >
                <img
                  src={
                    dbUser?.bot_config?.contact_info?.profile_picture ===
                    undefined
                      ? user?.picture
                      : dbUser?.bot_config?.contact_info?.profile_picture
                  }
                />
              </Dropdown>
            </SidebarFooter>
          </ProSidebar>
          <div className="panel">
            {/* {activePanelIndex == 0 && <h2>Choose your Goal</h2>} */}
            {/* {activePanelIndex == 0 &&
            (activeStep === 0 ? (
              <Goals
                setActiveStep={() => history.push("/dashboard/goals/platform")}
              />
            ) : (
              <Platform />
            ))} */}
            {activePanelIndex === 0 && <Community showOnly="conversations" />}
            {activePanelIndex === 1 && <Community showOnly="broadcasts" />}
            {activePanelIndex === 2 && <Playbook />}
            {activePanelIndex === 3 && <Collections />}
            {/* {activePanelIndex === 3 && <Insights />} */}
            {/* <Footer noBackground={true} /> */}
            <input
              ref={inputRef}
              type="file"
              id="input-file-upload"
              multiple={false}
              onChange={handleChange}
            />
          </div>
        </div>
      )}
      <InactiveModal isOpen={inactive} onCancel={() => setInactive(false)} />
    </div>
  );
}
